import React from 'react';
import { Button } from 'react-bootstrap';
import capa from '../assets/images/capa.png';
import logo from '../assets/images/logo.png';
import icon_preco from '../assets/images/icon_preco.png';
import icon_gov from '../assets/images/icon_gov.png';
import icon_base from '../assets/images/icon_base.png';
import icon_grafico from '../assets/images/icon_grafico.png';
import icon_excel from '../assets/images/icon_excel.png';
import icon_dados from '../assets/images/icon_dados.png';
import capa_app from '../assets/images/capa_app.png';
import google_play from '../assets/images/google_play.png';
import logo_white from '../assets/images/logo_white.png';

const Index = () => {
  return (
  <div className='cpu-home-background'>  
    <div className="container">
      <div className="row gx-0">
        <div className="col">
          <div className="d-flex justify-content-end">
            <div style={{position: 'absolute'}} className="pt-5">
              <img src={capa} width="570" alt=''/>
            </div>
          </div>
        </div>
      </div>

      <div className="row cpu-home-cimento gx-0">
        <div className="col-12">
          <div className="row">
            <div className="col offset-1 pt-4 pb-4">
              <img className="" src={logo} width="200" alt="CPUWEB" title="CPUWEB"/>
            </div>
          </div>
          <div className="row mt-4 pt-4 pb-2">
            <div className="col offset-1 cpu-home-title">Consulta fácil<br/>de preços.</div>
          </div>
        </div>
      </div>

      <div className="row bg-white gx-0">

        <div className="col-12">

          <div className="row">
            <div className="col offset-1 cpu-home-subtitle">Insumos ou Serviços<br />base da construção civil.</div>
          </div>
          <div className="row pt-5 mt-5">
            <div className="col offset-1">
              <Button href="#saibamais" size="lg" className="cpu-btn-secondary me-2">SAIBA MAIS</Button>
              <Button href="/sign-in" size="lg" className="cpu-btn-primary">LOGIN</Button>
            </div>
          </div>

          <div className="row pt-5 mt-5 pb-5 mb-5 bg-light gx-0 ">
            <div className="col">
              <figure className="text-center">
                <blockquote className="blockquote">
                  <p>Obtenha preços atualizados de <b>INSUMOS</b> ou <b>SERVIÇOS</b> <br/>
                    em diferentes estados ou se quiser fazer um estudo mais<br/>
                    aprofundado você pode até escolher datas mais antigas!</p>
                </blockquote>
              </figure>
            </div>
          </div>

          <div className="row pt-3" id="saibamais">
            <div className="col text-center">
              <p className="fs-2">RECURSOS DISPONÍVEIS</p>
            </div>
          </div>

          <div className="row pt-3">
            <div className="col-4 text-center">
              <img src={icon_preco} className="cpu-home-icon" alt=''/>
              <br/>
              Preços de referência<br/>para insumos e serviços
            </div>
            <div className="col-4 text-center">
              <img src={icon_gov} className="cpu-home-icon" alt=''/>
              <br/>
              Serviços de<br/>orgãos públicos
            </div>
            <div className="col-4 text-center">
              <img src={icon_base} className="cpu-home-icon" alt=''/>
              <br/>
              Bases<br/>Atualizadas
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-4 text-center">
              <img src={icon_grafico} className="cpu-home-icon" alt='' />
              <br />
              Relatórios Gráficos
            </div>
            <div className="col-4 text-center">
              <img src={icon_excel} className="cpu-home-icon" alt='' />
              <br/>
              Exportação<br/>dados em Excel
            </div>
            <div className="col-4 text-center">
              <img src={icon_dados} className="cpu-home-icon" alt='' />
              <br/>
              Banco de<br/>serviços base
            </div>
          </div>

          <div className="row mt-5 pt-3 pb-3 justify-content-center bg-light gx-0">
            <div className="col-6 text-center pt-4">
              <b>CPUWEB</b> é um sistema atualizado periódicamente com os preços de insumos, serviços e serviços de todos os estados do Brasil, permitindo que você faça um orçamento de projeto preciso e calculando margens sem ter surpresa no final.
            </div>
          </div>

          <div className="row mt-5 mb-5 justify-content-center gx-0">
            <div className="col-8 text-center p-4">

              <div className="card text-white bg-orange">
                <img src={capa_app} className="card-img-top" width="" alt=''/>
                <div className="card-body">
                  <h3 className="card-title">CPUWEB</h3>
                  <p className="card-text fs-5">Conheça nosso App e desfrute das facilidades mesmo em campo na obra ou na loja comprando materiais!</p>
                  <div className="mt-3">
                    <img src={google_play} width="200" alt=''/>
                  </div>
                </div>
              </div>

            </div>
          </div>


          <div className="row pt-3 mb-5 justify-content-center bg-light gx-0">
            <div className="col-6 text-center p-4">
              <i className="fs-4 lead">Faça seu cadastro agora mesmo!<br />É simples, fácil e rápido. Você começa a desfrutar de todas as facilidades agora mesmo!</i>
              <br />
              <br />
              <a href="/sign-up" className="btn btn-lg cpu-btn-primary">CADASTRE-SE</a>
            </div>
          </div>

          <div className="row gx-0">
            <div className="col" style={{height: '100px'}}>
              &nbsp;
            </div>
          </div>


        </div>
      </div>
    </div>


    <div className="container">
      <div className="row align-items-center gx-0 bg-orange">
        <div className="col-2 pt-2 pb-2 text-center"><img src={logo_white} height="40" alt=''/></div>
        <div className="col-8 cpu-home-footer text-center">
          Acesso imediato ás bases de dados atualizadas para orçamentos e comparativos de custos, 100% na web.<br/>
          Venha conhecer!
        </div>
        <div className="col-2">&nbsp;</div>
      </div>
    </div>
  </div>
  );
};

export default Index;